import { ActionContext } from 'vuex';
import outboundNotifications from '@/shared/services/outbound-notifications';
import { IApiResponse, IMetaResponse, IAutoResponderConfig } from '@/shared';

export default {
  namespaced: true,
  state: {
    single: undefined,
    categories: undefined,
  },
  getters: {
    single: (state: any) => ({ ...state.single?.data || {} }),
    categories: (state: any) => ([...state.categories?.categories || []]),
  },
  mutations: {
    set: (state: any, payload: IApiResponse<IAutoResponderConfig, IMetaResponse>) => {
      state.single = payload;
    },
    reset: (state: any) => {
      state.single = undefined;
    },
    setCategories: (state: any, payload: any[]) => {
      state.categories = payload;
    },
  },
  actions: {
    get: async (ctx: ActionContext<any, any>, clientId: number) => {
      const result = await outboundNotifications.get(clientId);
      ctx.commit('set', result);
    },
    post: async (ctx: ActionContext<any, any>, payload: any) => {
      const result = await outboundNotifications.post(payload);
      ctx.commit('set', result);
    },
    send: async (ctx: ActionContext<any, any>, payload: any) => {
      await outboundNotifications.send(payload);
    },
    getCategories: async (ctx: ActionContext<any, any>, clientId: number) => {
      const result = await outboundNotifications.getCategories(clientId);
      ctx.commit('setCategories', result);
    },
  },
};
